const state = {
  company: false
};

const getters = {

  company (state) {
    return state.company;
  }

};

const mutations = {

  storeCompany (state, company) {
    Vue.set(state, 'company', company);
  },

  clearCompany (state) {
    Vue.set(state, 'company', false);
  }

};

const actions = {
  
  fetchCompany({commit}, company) {

    return window.server.getReq('/company/' + company)
    .then(data => {
      commit('storeCompany', data);
      return Promise.resolve(data);
    })
    .catch(e => {
      console.log('store - actions.fetchCompany Error:', e);
      return Promise.reject(e);
    });
  }

};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/company.js